module.exports = __webpack_public_path__ + "assets/img/s12.7fe09318.png";